import { render, staticRenderFns } from "./ServidorConsentimento.vue?vue&type=template&id=fec87f58&scoped=true&"
import script from "./ServidorConsentimento.vue?vue&type=script&lang=js&"
export * from "./ServidorConsentimento.vue?vue&type=script&lang=js&"
import style0 from "./ServidorConsentimento.vue?vue&type=style&index=0&id=fec87f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec87f58",
  null
  
)

export default component.exports